import { MockRoute } from '../mockBackend';
import {
  PreviewIdentity,
  buildGroups,
  buildOrg,
  buildUser,
  readIntent,
} from '../../preview/previewIdentity';

// Serve layer for identity. The seed layer (bootstrapPreview) primes these same three caches for
// instant first paint; these handlers keep identity STABLE across React Query's refetch-on-mount
// (and App.getLoginUser refetches) — without them a refetch would hit the fail-closed dispatcher,
// reject, and collapse the chrome identity. Built from the SAME builders as the seed so they
// cannot diverge.

// Used only if the dispatcher is somehow hit before intent is written (shouldn't happen, since
// arming derives from intent). Keeps the mock fail-closed-but-stable rather than throwing.
const FALLBACK: PreviewIdentity = {
  fullName: 'Preview User',
  firstName: 'Preview',
  lastName: 'User',
  email: '',
  employeeId: 'preview-user',
  orgName: 'Sample Company',
};

function activeIdentity(): PreviewIdentity {
  return readIntent()?.identity ?? FALLBACK;
}

// The Settings layout (Settings.tsx) loads GET /Organization/Admin for any org admin on entering a
// /settings route — including /settings/learning (the Targeted Training Planning preview target).
// Minimal org-config payload covering every field OrganizationSettings.onDataReceived dereferences
// (the levelTypes/notificationTypes/locations arrays are .map/.forEach-ed without a guard).
function buildOrgAdmin(identity: PreviewIdentity) {
  return {
    organization: {
      organizationId: 'preview-org',
      name: identity.orgName, // KEEP REAL — chrome consistency with /Organization
      organizationIntegrations: [],
      showProficiency: true,
      address: null,
      enableJobMatching: false,
      allowJobMatchingConfig: false,
      levelTypes: [],
      notificationTypes: [],
      locations: [],
    },
  };
}

export const identityRoutes: MockRoute[] = [
  { pattern: '/User', build: () => buildUser(activeIdentity()) },
  { pattern: '/Organization', build: () => buildOrg(activeIdentity()) },
  { pattern: '/Organization/Admin', build: () => buildOrgAdmin(activeIdentity()) },
  { pattern: '/MyGroup', build: ({ dataset }) => buildGroups(dataset) },
];
